// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"TextComponent_themeRoot__fBT3V","gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__8dWLa"};